import request from "./axiosConfig";

export const getStudentProfile = () => {
  return request({
    url: "/interface/studentprofile",
    method: "get",
  });
};

export const saveStudentProfile = (data) => {
  return request({
    url: "/interface/studentprofile",
    method: "post",
    data,
  });
};
